export const conditions = {
  good: { value: 'good', text: 'Good' },
  fair: { value: 'fair', text: 'Fair' },
  poop: { value: 'poor', text: 'Poor' },
};

export const conditionsList = Object.values(conditions);

export const matchStatuses = {
  tis: {
    key: 'TIS',
    label: 'TC',
  },
  fsm: {
    key: 'FSM',
    label: 'FSM',
  },
  matched: {
    key: 'matched',
    label: 'Matched',
  },
  archived: {
    key: 'archived',
    label: 'Archived',
  },
};
